import React from 'react';
const blocks = [{
  name: 'Warm-up',
  min: 10,
  color: 'bg-white/25',
  text: 'text-white'
}, {
  name: 'Ball control',
  min: 10,
  color: 'bg-indigo',
  text: 'text-white'
}, {
  name: 'Skill A',
  min: 20,
  color: 'bg-coral',
  text: 'text-white'
}, {
  name: 'Skill B',
  min: 15,
  color: 'bg-teal',
  text: 'text-white'
}, {
  name: 'Small-sided',
  min: 15,
  color: 'bg-amber',
  text: 'text-ink'
}, {
  name: '6v6',
  min: 15,
  color: 'bg-white/40',
  text: 'text-ink'
}, {
  name: 'Cool-down',
  min: 5,
  color: 'bg-white/15',
  text: 'text-white'
}];
const coverage = [{
  label: 'Run Sheet',
  body: 'The whole practice on one page: objective, warm-up, timed blocks, a small-sided game and a 6v6 — minute by minute'
}, {
  label: 'Drill Cards',
  body: 'Each drill with its court setup, the coaching cue, the #1 error and the fix, and a by-level version'
}, {
  label: '45 · 60 · 90–120 min',
  body: 'Same session, three clocks — the minutes are already worked out for your slot'
}, {
  label: 'New · Developing · Advanced',
  body: 'Every drill scales three ways, so your whole squad works the same drill at its own level'
}, {
  label: 'Worksheet + Field Card',
  body: 'A print-and-keep worksheet for the session, plus a pocket card you take to the gym'
}, {
  label: 'Safety first',
  body: 'Pain, head knock or bad landing → stop and send to the trainer; clear landings, no contact at the net'
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full bg-ink text-white" data-id="element-262" data-mp="s34s4evharkv">
      <div className="apparatus-strip h-1.5 w-full" aria-hidden="true" data-id="element-263" data-mp="w2wxkipkshm0" />
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-264" data-mp="1131do7mknabp">
        <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-amber" data-id="element-265" data-mp="114uidhdmjkh2">The system</p>
        <h2 id="mechanism-heading" className="mt-3 font-display text-3xl font-extrabold text-white sm:text-5xl" data-id="element-266" data-mp="15zi08xe4hgmo">
          The Session Formula
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-white/80 sm:text-lg" data-id="element-267" data-mp="2hfymb9k6mvii">
          Practice plans aren&apos;t new. Practices you can actually walk in and
          run are. A template leaves you to fill in the session; a pile of drills
          leaves you to build it. Here every week of the year comes solved: a{' '}
          <span className="font-semibold text-white" data-id="element-268" data-mp="21qa9256fng63">Run Sheet</span> that runs the
          whole practice block by block, and{' '}
          <span className="font-semibold text-white" data-id="element-269" data-mp="1924pvmv11z8d">Drill Cards</span> that give you
          the exact setup, the cue and the by-level version of every drill. Open the
          week, print the sheet, run it.
        </p>

        <div className="mx-auto mt-9 max-w-3xl text-left" data-id="element-270" data-mp="1isfs94z2c0d5">
          <p className="text-[11px] font-semibold uppercase tracking-widest text-white/60" data-id="element-271" data-mp="1iu0qp5oi03ga">A 90-minute practice</p>
          <div className="mt-2 flex h-11 w-full overflow-hidden rounded-xl border border-ink-line" data-id="element-272" data-mp="qbmypmpufbp4">
            {blocks.map(b => <div key={b.name} style={{
            flexGrow: b.min,
            flexBasis: 0
          }} className={`${b.color} ${b.text} flex items-center justify-center font-display text-sm font-extrabold sm:text-base`} data-id="element-273" data-mp="lbqrzfprh65v">
                {b.min}′
              </div>)}
          </div>
          <ol className="mt-3 grid grid-cols-2 gap-x-4 gap-y-1.5 text-[12.5px] text-white/75 sm:grid-cols-4 lg:grid-cols-7" data-id="element-274" data-mp="2n3sl3uk1cwuk">
            {blocks.map((b, i) => <li key={b.name} className="flex items-center gap-1.5" data-id="element-275" data-mp="3frok55x2v0ui" data-mpi={i}>
                <span className={`h-2.5 w-2.5 flex-none rounded-sm ${b.color}`} data-id="element-276" data-mp="3kphmfnv9fapi" />
                {i + 1}. {b.name}
              </li>)}
          </ol>
        </div>

        <ul className="mt-10 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-277" data-mp="36sb5zzy0do3g">
          {coverage.map(item => <li key={item.label} className="rounded-xl border border-ink-line bg-white/5 px-4 py-3" data-id="element-278" data-mp="1vb1npgqm923q">
              <span className="block text-[11px] font-semibold uppercase tracking-widest text-amber" data-id="element-279" data-mp="1zcwomk4mxdgz">{item.label}</span>
              <span className="mt-1 block text-sm text-white/85" data-id="element-280" data-mp="2fkl206m6fcoa">{item.body}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}